<app-sidenav>
  <div class="container-fluid p-5">
    <h3 class="title-page pt-2 pl-5 mt-4">Edição de representantes</h3>
    <div class="editar-representante-page" *ngIf="formEmpresa">
      <div class="bullet-title mt-4">
        <span>1</span>
        <h3>Dados dos Representantes</h3>
      </div>
      <div class="d-flex justify-content-center align-items-center mt-4">
        <span class="info">Confirme ou edite os dados dos Representantes Legais da empresa</span>
      </div>
      <div class="custom-box-alert mt-5 mb-5">
        <i class="fas fa-info-circle"></i>
        <p>O Representante Legal da empresa será responsável por todos os atos em nome da Pessoa Jurídica. É obrigatório o cadastro de ao menos 01 (um) Representante Legal que possui poderes de representação conforme Estatuto ou Contrato Social da empresa.</p>
      </div>

      <div class="custom-box mt-5 p-5">
        <form id="formEmpresas" [formGroup]="formEmpresa">
          <div class="form-row mt-3">
            <div class="form-group col-6">
              <label class="form-label">CNPJ</label>
              <input formControlName="cnpj" autocomplete="off" mask="AA.AAA.AAA/AAAA-AA" class="form-control custom-input form-adaptable form-icon-trailing" />
            </div>
            <div class="form-group col-6">
              <label class="form-label">Razão Social *</label>
              <input formControlName="nomeEmpresa" autocomplete="off" maxlength="150" class="form-control custom-input form-adaptable form-icon-trailing" />
              <span class="error-form ml-2" *ngIf="formEmpresa.get('nomeEmpresa')?.hasError('required') && (formEmpresa.get('nomeEmpresa').dirty || formEmpresa.get('nomeEmpresa').touched)">Campo obrigatório.</span>
              <span class="error-form ml-2" *ngIf="formEmpresa.get('nomeEmpresa')?.hasError('pattern')">Campo contém caracteres inválidos.</span>
            </div>
            <div class="form-group col-6 mb-5">
              <span class="info-text"><i class="fas fa-info-circle"></i> Campo não editável</span>
            </div>
          </div>
          <hr />

          <div formArrayName="representantes">
            <div *ngFor="let rep of representantes.controls; let i = index" [formGroupName]="i" class="mt-5">
              <h2 class="title-section mb-4">
                <i class="fas fa-edit"></i> Representante Legal {{ i + 1 }}
                <span class="badge badge-solid" *ngIf="i === 0">Obrigatório</span>
                <span class="badge badge-outline" *ngIf="i === 1">Se aplicável</span>
              </h2>
              <p class="subtitle-section mb-5">Pessoa com poderes de assinar em nome da empresa</p>
              <hr>
              <div class="form-row mt-3">
                <div class="form-group col-12">
                  <label class="form-label">Nome Completo <b *ngIf="i === 0">*</b></label>
                  <input formControlName="nome" autocomplete="off" maxlength="150" placeholder="Nome Completo" class="form-control custom-input form-adaptable form-icon-trailing" />
                  <span class="error-form ml-2" *ngIf="rep.get('nome').hasError('required') && (rep.get('nome').dirty || rep.get('nome').touched)">Campo obrigatório.</span>
                </div>
                <div class="form-group col-6 mt-3">
                  <label class="form-label">E-mail <b *ngIf="i === 0">*</b></label>
                  <input formControlName="emailPj" autocomplete="off" placeholder="exemplo@exemplo.com" class="form-control custom-input form-adaptable form-icon-trailing" />
                  <span class="error-form ml-2" *ngIf="rep.get('emailPj').hasError('required') && (rep.get('emailPj').dirty || rep.get('emailPj').touched)">Campo obrigatório.</span>
                  <span class="error-form ml-2" *ngIf="rep.get('emailPj')?.hasError('emailInvalid') && rep.get('emailPj')?.dirty">E-mail inválido.</span>
                </div>
                <div class="form-group col-6 mt-3">
                  <label class="form-label">CPF <b *ngIf="i === 0">*</b></label>
                  <input formControlName="cpf" autocomplete="off" placeholder="000.000.000-00" mask="000.000.000-00" class="form-control custom-input form-adaptable form-icon-trailing" />
                  <span class="error-form ml-2" *ngIf="rep.get('cpf').hasError('required') && (rep.get('cpf').dirty || rep.get('cpf').touched)">Campo obrigatório.</span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="form-row mt-5">
        <div class="form-group col-12 d-flex justify-content-center g-3">
          <button data-testid="botao-voltar" class="btn voltar mr-5" (click)="voltar()">← Voltar</button>
          <button data-testid="botao-continuar" class="btn continuar " (click)="updateEmpresa()">Continuar</button>
        </div>
      </div>
    </div>
  </div>
</app-sidenav>
